import PropTypes from 'prop-types';

import styles from './PatchTestModalContent.scss';

export const PatchTestModalContent = ({ branchPhone }) => (
  <div className={styles.PatchTestModalContent}>
    <div>
      <p className={styles.PatchTestModalContent__require}>
        A patch test is required before you have this treatment.
      </p>
      <p>
        This is very important to make sure that you do not have an allergic reaction to the
        product.
      </p>
    </div>

    <div>
      <h2>How does it work?</h2>
      <p>
        The patch test involves a small amount of product that will be applied either behind your
        ear or on the inside of your elbow.
      </p>
      <p>
        A patch test may need to be repeated if you have not had a colour, lash or tint service for
        a period of time or if your health has changed. Please contact the shop on
        <span className={styles.PatchTestModalContent__require}>{` ${branchPhone} `}</span>
        to check as without a patch test we may be unable to carry out the service.
      </p>
    </div>

    <div>
      <h2>Do I need an appointment?</h2>
      <p>
        No, you don&apos;t need to make an appointment for a patch test. Simply visit the shop and
        we can carry out the test within a few minutes.
      </p>
    </div>
  </div>
);

PatchTestModalContent.propTypes = {
  branchPhone: PropTypes.string.isRequired,
};
